var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q, Api } from "@http";
import { observable, action, runInAction, toJS, computed, reaction } from "mobx";
import { paramChecker } from "@common/decorator";
import { PredefinePriority, PredefinedServiceCategory, PredefinedWoType, PredefinedProcareProjectWOType, PredefinedProcareProjectWOTypeRename, SessionKey, EventLogReferenceType, ScheduleEntryType, ScheduleType, RecommendType } from "@common/enums/base";
import { includes, debounce } from "lodash-es";
import AutoSchedule from "@store/requestRepair/createWO/autoSchedule";
import AutoScheduleWithLastVersion from "@store/requestRepair/createWO/autoScheduleWithLastVersion";
import Question from "./entity/question";
import { getLocationId, isIH, isWPH, toCamelCaseData } from "@common/utils";
import { AbFeatures } from "@common/utils/abFeature";
import moment from "moment";
import CreateReactiveWO from "@store/requestRepair/entity/createReactiveWOEntity";
import LoadingData from "@store/common/loadingData";
import { cookie } from "@common/utils/storage";
import PreferredTimeCapture from "@store/requestRepair/createWO/preferredTimeCapture";
import axios from "axios";
var regionalScriptFilterWoTypes = [
    PredefinedWoType.Recall,
    PredefinedWoType.ResidentResponsibility
];
var CreateWOStore = /** @class */ (function () {
    function CreateWOStore() {
        var _this = this;
        this.regionScriptPriority = null;
        this.isPriorityBeRegionScriptModify = false;
        this.regionScriptClientNTE = null;
        this.regionScriptWoTypeId = null;
        this.storePriorityIdParam = null;
        this.storeWOTypeIdParam = null;
        this.isRecallWo = false;
        this.hasRegionalScriptFutureToggle = false;
        this.urgentIHTNoRecommendSpecificProcess = false;
        this.hasDataInNotIH = false;
        this.isCanServiceScheduleOptimization = false;
        this.attachments = [];
        this.predictSearchListLoadingData = new LoadingData([]);
        this.getPredictSearchListInnerFn = function () {
            runInAction(function () {
                _this.predictSearchListLoadingData.setLoading();
                return _this.api()
                    .getPredictSearchList(_this.predictSearchValue)
                    .then(function (data) {
                    runInAction(function () {
                        var rowData = toCamelCaseData(data);
                        _this.predictSearchListLoadingData.setUnLoading();
                        _this.predictSearchListLoadingData.setLoadedData(rowData.predictservice);
                    });
                });
            });
        };
        this.getPredictSearchList = debounce(this.getPredictSearchListInnerFn, 500);
        this.defaultPriority = {
            Priority: {},
            ServiceCode: {}
        };
        this.serviceCodeWOType = null;
        this.commonQuestion = [];
        this.serviceCodeQuestion = [];
        this.allPriority = null;
        this.gateCode = null;
        this.isCAHManaged = false;
        this.holidays = [1, 7];
        this.future24hoursMaxApparentTempInfo = {};
        this.isAutoScheduleRegion = false;
        this.scheduleDate = { date: null, availableDates: [] };
        this.serviceIssue = "";
        this.accessInformation = "";
        this.isNowCreateProCare = false;
        this.proCareProject = {};
        this.locationId = '0';
        this.isLastVersionAutoSchedule = undefined;
        this.isEnableResidentSchedule = false;
        this.autoSchedule = new AutoSchedule(this);
        this.createReactiveEntity = new CreateReactiveWO();
        this.autoScheduleWithLastVersion = new AutoScheduleWithLastVersion(this);
        this.preferredTimeCapture = new PreferredTimeCapture(this);
        this.initReactive();
    }
    Object.defineProperty(CreateWOStore.prototype, "serviceParam", {
        get: function () {
            return {
                serviceCategoryId: this.serviceCategoryId,
                serviceTypeId: this.serviceTypeId,
                serviceCodeId: this.serviceCodeId
            };
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.initReactive = function () {
        var _this = this;
        reaction(function () { return _this.commonQuestion.concat(_this.serviceCodeQuestion).map(function (question) {
            var option = question.QuestionOptions.find(function (option) { return option.Id === question.answerId; });
            return (option && option.PriorityId) || null;
        }); }, function (priorities) {
            _this.future24hoursMaxApparentTempInfo.isSelectHeatIndexOption = includes(priorities, PredefinePriority.FeelsLike);
        });
    };
    Object.defineProperty(CreateWOStore.prototype, "isProcare", {
        get: function () {
            return (this.serviceCategoryId === PredefinedProcareProjectWOType.ServiceCategoryId &&
                this.serviceTypeId === PredefinedProcareProjectWOType.ServiceTypeId &&
                this.serviceCodeId === PredefinedProcareProjectWOType.ServiceCodeId) || (this.serviceCategoryId === PredefinedProcareProjectWOTypeRename.ServiceCategoryId &&
                this.serviceTypeId === PredefinedProcareProjectWOTypeRename.ServiceTypeId &&
                this.serviceCodeId === PredefinedProcareProjectWOTypeRename.ServiceCodeId);
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.initNoAvailableChecked = function () {
        this.autoScheduleWithLastVersion.noAvailableChecked &&
            this.autoScheduleWithLastVersion.toggleNoAvailableChecked();
        this.autoSchedule.noAvailableChecked &&
            this.autoSchedule.toggleNoAvailableChecked();
    };
    CreateWOStore.prototype.resetPredictSearch = function () {
        this.predictSearchValue = "";
        this.predictSearchListLoadingData.setUnLoading();
        this.predictSearchListLoadingData.set([]);
    };
    CreateWOStore.prototype.setPredictSearchValue = function (value) {
        this.predictSearchValue = value;
    };
    CreateWOStore.prototype.getPhoneNumber = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getPhoneNumber()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.phoneNumber = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.setAttachments = function (attachments) {
        this.attachments = attachments;
    };
    CreateWOStore.prototype.addAttachment = function (attachment) {
        this.attachments.push(attachment);
    };
    CreateWOStore.prototype.removeAttachment = function (attachment) {
        this.attachments = this.attachments.filter(function (x) { return x !== attachment; });
    };
    CreateWOStore.prototype.setReactiveWO = function (key, value) {
        //@ts-ignore
        this.createReactiveEntity[key] = value;
    };
    CreateWOStore.prototype.updateSubtaskStatusEventLog = function (params) {
        return this.api().updateSubtaskStatusEventLog(params);
    };
    Object.defineProperty(CreateWOStore.prototype, "priorityId", {
        get: function () {
            return this.defaultPriority && this.defaultPriority.PriorityId;
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.resetPriorityId = function () {
        this.defaultPriority = {
            Priority: {},
            ServiceCode: {}
        };
    };
    Object.defineProperty(CreateWOStore.prototype, "commonQuestionAnswer", {
        get: function () {
            return this.commonQuestion.length > 0
                ? Question.toAnswer(this.commonQuestion)
                : this.getQuestionAnswerFromSession(SessionKey.CommonQuestion) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "serviceCodeQuestionAnswer", {
        get: function () {
            return this.serviceCodeQuestion.length > 0
                ? Question.toAnswer(this.serviceCodeQuestion)
                : this.getQuestionAnswerFromSession(SessionKey.ServiceCodeQuestion) || [];
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.isIH = function () {
        return isIH() || isWPH();
    };
    Object.defineProperty(CreateWOStore.prototype, "priority", {
        get: function () {
            var priorities = this.commonQuestion.concat(this.serviceCodeQuestion).map(function (question) {
                var option = question.QuestionOptions.find(function (option) { return option.Id === question.answerId; });
                return (option && option.PriorityId) || null;
            });
            var isSelectHeatIndexOption = includes(priorities, PredefinePriority.FeelsLike);
            if (this.serviceCategoryId === PredefinedServiceCategory.AirConditioningHeating &&
                this.future24hoursMaxApparentTempInfo.isActive &&
                isSelectHeatIndexOption) {
                priorities.push(this.future24hoursMaxApparentTempInfo.priorityId);
            }
            priorities = priorities.filter(function (i) { return i !== null; });
            var priority = priorities.length > 0 ? (this.getHighestPriority(priorities) || this.priorityId) : this.priorityId;
            this.createReactiveEntity.priorityId = priority;
            console.log("priority change to: ", priority);
            return priority;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "showPreferedWindow", {
        get: function () {
            return !this.isProcare && !this.isAutoSchedule && (this.isInHouseTechnician && !this.criticalOrEmergency);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "woTypeId", {
        get: function () {
            var answers = this.commonQuestion.concat(this.serviceCodeQuestion);
            var woTypes = answers
                .map(function (answer) {
                var questionOption = answer.QuestionOptions.find(function (item) { return item.Id === answer.answerId; });
                return (questionOption && questionOption.WOTypeId) || null;
            })
                .filter(function (x) { return !!x; });
            var woTypeId = this.serviceCodeWOType;
            if (woTypes && woTypes.length > 0) {
                woTypeId = Math.min.apply(null, woTypes);
            }
            console.log('WoTypeId:', woTypeId);
            return woTypeId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "shouldRegionalScript", {
        get: function () {
            return (!this.isRecallWo && regionalScriptFilterWoTypes.indexOf(this.woTypeId) < 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "isInHouseTechnician", {
        get: function () {
            return this.regionScriptWoTypeId !== null ? this.regionScriptWoTypeId === PredefinedWoType.InHouseTechnician
                : this.woTypeId === PredefinedWoType.InHouseTechnician;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "notRecall", {
        get: function () {
            var computedWoType = this.regionScriptWoTypeId !== null ? this.regionScriptWoTypeId : this.woTypeId;
            return (!this.isRecallWo && computedWoType !== PredefinedWoType.Recall);
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.getProcareProject = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getProcareProject();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            !!data ? (_this.proCareProject = data) : (_this.isNowCreateProCare = true);
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CreateWOStore.prototype.getisLastVersionAutoSchedule = function () {
        var _this = this;
        var locationId = cookie("locationId");
        if (!locationId || !isIH())
            return;
        this.api().hasVisitAndScheduleCalendarAbmodule(locationId).then(function (hasVisitAndScheduleCalendarAbmodule) {
            runInAction(function () {
                _this.isLastVersionAutoSchedule = hasVisitAndScheduleCalendarAbmodule;
            });
        });
    };
    CreateWOStore.prototype.getIsEnableResidentSchedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isIH()) {
                            this.isEnableResidentSchedule = true;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api().isEnableResidentSchedule()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isEnableResidentSchedule = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CreateWOStore.prototype, "isAutoSchedule", {
        get: function () {
            if (!isIH())
                return this.isCanServiceScheduleOptimization && this.isEnableResidentSchedule;
            var isSupportLastVersionAutoSchedule = this.isLastVersionAutoSchedule || this.isAutoScheduleRegion;
            var isConfigRegionScript = (this.regionScriptPriority !== null) && (this.regionScriptPriority !== PredefinePriority.Critical) &&
                (this.regionScriptPriority !== PredefinePriority.Emergency);
            var conformTypeLimit = isIH() ? this.isInHouseTechnician : this.notRecall && this.shouldRegionalScript;
            var isAutoSchedule = (conformTypeLimit &&
                !this.isProcare &&
                isSupportLastVersionAutoSchedule &&
                (isConfigRegionScript || ((this.regionScriptPriority === null) &&
                    (this.priority !== PredefinePriority.Emergency) &&
                    (this.priority !== PredefinePriority.Critical))) &&
                this.isEnableResidentSchedule &&
                !this.isCAHManaged);
            return isAutoSchedule;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "criticalOrEmergency", {
        get: function () {
            return this.priority === PredefinePriority.Emergency || this.priority === PredefinePriority.Critical;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateWOStore.prototype, "isDisplayFuture24hoursMaxApparentTempInfo", {
        get: function () {
            return (this.serviceCategoryId === PredefinedServiceCategory.AirConditioningHeating &&
                this.future24hoursMaxApparentTempInfo.isActive &&
                this.future24hoursMaxApparentTempInfo.isSelectHeatIndexOption);
        },
        enumerable: false,
        configurable: true
    });
    CreateWOStore.prototype.getHighestPriority = function (prioritys) {
        return [
            PredefinePriority.Critical,
            PredefinePriority.Emergency,
            PredefinePriority.NextAvailableService,
            PredefinePriority.RoutineExpeditedService,
            PredefinePriority.RoutineStandardService,
            PredefinePriority.Expedited,
            PredefinePriority.TuneUp,
            PredefinePriority.ResidentResponsibility
        ].find(function (priority) { return includes(prioritys, priority); });
    };
    CreateWOStore.prototype.setServiceParam = function (param) {
        this.serviceCategoryId = param.serviceCategoryId;
        this.serviceTypeId = param.serviceTypeId;
        this.serviceCodeId = param.serviceCodeId;
    };
    CreateWOStore.prototype.getDefaultPriority = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetPriorityId();
                        return [4 /*yield*/, this.api().getDefaultPriority(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.defaultPriority = data;
                            _this.createReactiveEntity.problemDescription =
                                data && data.ServiceCode.ServiceType
                                    ? data.ServiceCode.ServiceType.ServiceCategory.Name + " > " + data.ServiceCode.ServiceType.Name + " > " + data.ServiceCode.Name
                                    : "";
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getServiceCodeWOType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getServiceCodeWOType(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.serviceCodeWOType = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getCommonQuestion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCommonQuestion(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.commonQuestion = Question.serialization(data);
                            Question.fromAnswer(_this.commonQuestion, _this.getQuestionAnswerFromSession(SessionKey.CommonQuestion));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getServiceCodeQuestion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getServiceCodeQuestion(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.serviceCodeQuestion = Question.serialization(data);
                            Question.fromAnswer(_this.serviceCodeQuestion, _this.getQuestionAnswerFromSession(SessionKey.ServiceCodeQuestion));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getAllPriority = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getAllPriority(this.serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.allPriority = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getQuestionAnswerFromSession = function (sessionKey) {
        return JSON.parse(sessionStorage.getItem(sessionKey));
    };
    CreateWOStore.prototype.setScheduleDate = function (date) {
        this.scheduleDate = date;
    };
    CreateWOStore.prototype.getIsAutoScheduleRegion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getIsAutoScheduleRegion()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isAutoScheduleRegion = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getGateCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getGateCode()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.gateCode = data;
                            if (!_this.accessInformation && _this.gateCode) {
                                _this.setAccessInformation("Gate Code: " + _this.gateCode);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getIsCAHManaged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getIsCAHManaged()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isCAHManaged = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getHolidays = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getHolidays()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            (data || []).map(function (item) {
                                var date = new Date(item);
                                _this.holidays.push([date.getFullYear(), date.getMonth(), date.getDate()]);
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.getFuture24hoursMaxApparentTempInfo = function (clientId, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getFuture24hoursMaxApparentTempInfo(clientId, locationId)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.future24hoursMaxApparentTempInfo = __assign(__assign({}, data), { isSelectHeatIndexOption: false });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.checkCreateWoScheduleTime = function (query) {
        return this.api().checkCreateWoScheduleTime(query, this.serviceParam);
    };
    CreateWOStore.prototype.createWOCommit = function (query) {
        return this.api().createWOCommit(query, this.serviceParam);
    };
    CreateWOStore.prototype.setCommonQuestionAnswer = function (questionId, answer, answerId) {
        var question = this.findQuestionById(this.commonQuestion, questionId);
        if (question) {
            question.answer = answer;
            question.answerId = answerId;
        }
    };
    CreateWOStore.prototype.logRegionalScriptChange = function (woId) {
        if (!this.shouldRegionalScript)
            return;
        if (!this.hasRegionalScriptFutureToggle)
            return;
        var params = {
            woId: woId,
            sourceData: {
                PriorityId: this.storePriorityIdParam,
                WoTypeId: this.storeWOTypeIdParam,
                ClientNTE: null
            },
            EventLogReferenceType: EventLogReferenceType.ReactiveWO,
        };
        return this.api().regionalScriptLog(params);
    };
    CreateWOStore.prototype.setServiceCodeQuestionAnswer = function (questionId, answer, answerId) {
        var question = this.findQuestionById(this.serviceCodeQuestion, questionId);
        if (question) {
            question.answer = answer;
            question.answerId = answerId;
        }
    };
    CreateWOStore.prototype.saveToSession = function () {
        sessionStorage.setItem(SessionKey.ScheduleDate, JSON.stringify(toJS(this.scheduleDate)));
        sessionStorage.setItem(SessionKey.Attachments, JSON.stringify(toJS(this.attachments)));
        sessionStorage.setItem(SessionKey.CommonQuestion, JSON.stringify(toJS(Question.toAnswer(this.commonQuestion))));
        sessionStorage.setItem(SessionKey.ServiceCodeQuestion, JSON.stringify(toJS(Question.toAnswer(this.serviceCodeQuestion))));
        sessionStorage.setItem(SessionKey.ServiceIssue, this.serviceIssue || "");
        sessionStorage.setItem(SessionKey.AccessInformation, this.accessInformation || "");
        sessionStorage.setItem(SessionKey.ReactiveWo, JSON.stringify(toJS(this.createReactiveEntity)));
    };
    CreateWOStore.prototype.loadFromSession = function () {
        var scheduleDate = JSON.parse(sessionStorage.getItem(SessionKey.ScheduleDate));
        if (scheduleDate) {
            this.scheduleDate = {
                date: scheduleDate.date ? moment(scheduleDate.date) : null,
                availableDates: scheduleDate.availableDates.filter(function (i) { return !!i; }).map(function (date) { return moment(date); })
            };
        }
        this.attachments = JSON.parse(sessionStorage.getItem(SessionKey.Attachments)) || this.attachments;
        this.serviceIssue = sessionStorage.getItem(SessionKey.ServiceIssue) || this.serviceIssue;
        this.accessInformation = sessionStorage.getItem(SessionKey.AccessInformation) || this.accessInformation;
        this.createReactiveEntity = CreateReactiveWO.parse(JSON.parse(sessionStorage.getItem(SessionKey.ReactiveWo))) || this.createReactiveEntity;
        this.autoSchedule.loadFromSession();
        this.autoScheduleWithLastVersion.loadFromSession();
    };
    CreateWOStore.prototype.cleanSession = function () {
        sessionStorage.removeItem(SessionKey.Attachments);
        sessionStorage.removeItem(SessionKey.ServiceIssue);
        sessionStorage.removeItem(SessionKey.AccessInformation);
        sessionStorage.removeItem(SessionKey.ReactiveWo);
        sessionStorage.removeItem(SessionKey.ScheduleDate);
        sessionStorage.removeItem(SessionKey.CommonQuestion);
        sessionStorage.removeItem(SessionKey.ServiceCodeQuestion);
        this.autoSchedule.cleanSession();
        this.autoScheduleWithLastVersion.cleanSession();
    };
    CreateWOStore.prototype.cleanData = function () {
        this.setAttachments([]);
        this.setAccessInformation('');
        this.setServiceIssue('');
        this.createReactiveEntity = new CreateReactiveWO();
        this.scheduleDate = { date: null, availableDates: [] };
        this.commonQuestion = [];
        this.serviceCodeQuestion = [];
        this.autoSchedule.cleanData();
    };
    CreateWOStore.prototype.findQuestionById = function (questions, questionId) {
        var _this = this;
        var result = null;
        questions.some(function (question) {
            if (question.Id === questionId) {
                result = question;
                return true;
            }
            var subQuestion = _this.findQuestionById(question.SubQuestions, questionId);
            if (subQuestion) {
                result = subQuestion;
                return true;
            }
            question.QuestionOptions.some(function (option) {
                var optionQuestion = _this.findQuestionById(option.SubQuestions, questionId);
                if (optionQuestion) {
                    result = optionQuestion;
                    return true;
                }
                return false;
            });
            return false;
        });
        return result;
    };
    CreateWOStore.prototype.setServiceIssue = function (serviceIssue) {
        this.serviceIssue = serviceIssue;
        this.createReactiveEntity.addtionalDetail = serviceIssue;
    };
    CreateWOStore.prototype.setAccessInformation = function (accessInformation) {
        this.accessInformation = accessInformation;
        this.createReactiveEntity.accessInformation = accessInformation;
    };
    CreateWOStore.prototype.getLocationInfo = function () {
        return this.api().getLocationInfo(this.serviceParam);
    };
    CreateWOStore.prototype.clearRegionScriptData = function () {
        this.regionScriptWoTypeId = null;
        this.regionScriptPriority = null;
        this.isPriorityBeRegionScriptModify = false;
        this.regionScriptClientNTE = null;
    };
    CreateWOStore.prototype.getRegionScript = function () {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldRegionalScript)
                            return [2 /*return*/];
                        this.storePriorityIdParam = this.priority;
                        this.storeWOTypeIdParam = this.woTypeId && Number(this.woTypeId);
                        promise = this.api().getRegionalScript({
                            priorityId: this.priority || 0,
                            serviceCodeId: this.serviceCodeId
                        });
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!!data) {
                                if ((data.woTypeId !== null) && (data.woTypeId !== _this.woTypeId)) {
                                    _this.regionScriptWoTypeId = data.woTypeId;
                                }
                                if ((data.priorityId !== null) && (data.priorityId !== _this.regionScriptPriority)) {
                                    _this.regionScriptPriority = data.priorityId;
                                    _this.isPriorityBeRegionScriptModify = true;
                                }
                                _this.hasRegionalScriptFutureToggle = true;
                            }
                            else {
                                _this.hasRegionalScriptFutureToggle = false;
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CreateWOStore.prototype.canServiceScheduleOptimization = function () {
        return __awaiter(this, void 0, void 0, function () {
            var param, cancelToken, data_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.cancel !== undefined) {
                            this.cancel();
                        }
                        if (isIH() || !this.priorityId) {
                            this.isCanServiceScheduleOptimization = false;
                            return [2 /*return*/, false];
                        }
                        ;
                        param = {
                            serviceCodeId: this.serviceCodeId,
                            priorityId: this.isPriorityBeRegionScriptModify ? this.regionScriptPriority : this.priority,
                            locationId: getLocationId(),
                            clientId: cookie("clientId"),
                            woTypeId: this.woTypeId,
                            residentId: cookie("residentId"),
                        };
                        cancelToken = new axios.CancelToken(function (c) {
                            _this.cancel = c;
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api().canServiceScheduleOptimization(param, cancelToken)];
                    case 2:
                        data_1 = _a.sent();
                        runInAction(function () {
                            if (data_1 === true) {
                                _this.isCanServiceScheduleOptimization = data_1;
                                _this.isLastVersionAutoSchedule = data_1;
                            }
                            else {
                                _this.isCanServiceScheduleOptimization = false;
                                _this.isLastVersionAutoSchedule = false;
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        runInAction(function () {
                            _this.isCanServiceScheduleOptimization = false;
                            _this.isLastVersionAutoSchedule = false;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.checkIsRecallWo = function (serviceCategoryId, serviceCodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var isRecallWo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().checkIsRecallWo({
                            serviceCategoryId: serviceCategoryId,
                            woTypeId: this.woTypeId || PredefinedWoType.WorkOrder,
                            serviceCodeId: serviceCodeId
                        })];
                    case 1:
                        isRecallWo = _a.sent();
                        runInAction(function () {
                            _this.isRecallWo = isRecallWo;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateWOStore.prototype.scheduleRecommandTrack = function (woId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, pullInRecommend, trackOption;
            return __generator(this, function (_b) {
                if (!this.autoScheduleWithLastVersion.autoScheduleRawData)
                    return [2 /*return*/];
                _a = this.autoScheduleWithLastVersion.autoScheduleRawData.pullInRecommend, pullInRecommend = _a === void 0 ? {} : _a;
                trackOption = this.autoScheduleWithLastVersion.selectedSchedule;
                if (!trackOption)
                    return [2 /*return*/];
                this.api().scheduleRecommandTrack({
                    refId: woId,
                    refType: ScheduleType.ReactiveWO,
                    trackData: pullInRecommend.trackData,
                    trackOption: trackOption,
                    scheduleEntryType: ScheduleEntryType.CreateWO
                });
                return [2 /*return*/];
            });
        });
    };
    CreateWOStore.prototype.urgentScheduleRecommandTrack = function (woId, priorityId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, pullInRecommend, trackData, recommends, topRecommends, type, recommendIn5Days, recommendAfter5Days, noRecommend;
            return __generator(this, function (_b) {
                if (!this.isAutoSchedule)
                    return [2 /*return*/];
                if (priorityId !== PredefinePriority.NextAvailableService)
                    return [2 /*return*/];
                _a = this.autoScheduleWithLastVersion.autoScheduleRawData.pullInRecommend, pullInRecommend = _a === void 0 ? {} : _a;
                trackData = pullInRecommend.trackData, recommends = pullInRecommend.recommends, topRecommends = pullInRecommend.topRecommends;
                type = null;
                recommendIn5Days = recommends.length > 0 || topRecommends.length > 0;
                recommendAfter5Days = !recommendIn5Days && trackData.length > 0;
                noRecommend = trackData.length <= 0;
                if (recommendIn5Days) {
                    type = RecommendType.recommendIn5Days;
                }
                else if (recommendAfter5Days) {
                    type = RecommendType.recommendAfter5Days;
                }
                else if (noRecommend) {
                    type = RecommendType.noRecommend;
                }
                this.api().urgentScheduleRecommandTrack({ woId: woId, type: type });
                return [2 /*return*/];
            });
        });
    };
    CreateWOStore.prototype.api = function () {
        return {
            getDefaultPriority: function (param) {
                return Q(http.post(buildURL(param) + "/defaultPriority"));
            },
            getServiceCodeWOType: function (param) {
                return Q(http.post(buildURL(param) + "/serviceCodeWOType"));
            },
            getCommonQuestion: function (param) {
                return Q(http.post(buildURL(param) + "/commonQuestion"));
            },
            getServiceCodeQuestion: function (param) {
                return Q(http.post(buildURL(param) + "/serviceCodeQuestion"));
            },
            getAllPriority: function (param) { return Q(http.post(buildURL(param) + "/allPriorty")); },
            getIsAutoScheduleRegion: function () {
                return Q(http.post(buildURL() + "/IsAutoScheduleRegion?_=" + new Date().getTime()));
            },
            getGateCode: function () { return Q(http.get(buildURL() + "/GateCode?_=" + new Date().getTime())); },
            getIsCAHManaged: function () { return Q(http.post(buildURL() + "/IsCAHManaged?_=" + new Date().getTime())); },
            getHolidays: function () { return Q(http.post(buildURL() + "/Getholidays?_=" + new Date().getTime())); },
            getProcareProject: function () { return Q(http.post("rsp/Procare/GetProcareProject")); },
            getFuture24hoursMaxApparentTempInfo: function (clientId, locationId) {
                return Q(http.post(buildURL() + "/GetFuture24hoursMaxApparentTempInfo?clientId=" + clientId + "&locationId=" + locationId + "&_=" + new Date().getTime()));
            },
            checkCreateWoScheduleTime: function (query, serviceParam) {
                return Q(http.post(buildURL(serviceParam) + "/CheckCreateWoScheduleTime", query, Api.withForm));
            },
            createWOCommit: function (query, serviceParam) {
                return Q(http.post(buildURL(serviceParam) + "/Commit", query, Api.withForm));
            },
            getPredictSearchList: function (value) { return Q(http.post("/RSP/NewRequest/GetPredictService", { value: value })); },
            getPhoneNumber: function () { return Q(http.post("/RSP/Dashboard/GetCallCenter")); },
            getLocationInfo: function (serviceParam) {
                return Q(http.post(buildURL(serviceParam) + "/locationInfo"));
            },
            updateSubtaskStatusEventLog: function (params) {
                return Q(http.post("/rsp/proCare/UpdateSubtaskStatusEventLog", params, Api.withForm));
            },
            hasVisitAndScheduleCalendarAbmodule: function (locationId) {
                return Q(http.post("/abmodule/hasabmodulepermissionByLocation", {
                    locationId: locationId,
                    abmodule: AbFeatures.VisitDrivenAndScheduleCalendar
                }));
            },
            getRegionalScript: function (params) {
                return Q(http.get("/RegionalScript/GetRegionalScript", { params: params }));
            },
            regionalScriptLog: function (params) {
                return Q(http.post("/RegionalScript/RegionalScriptLog", params));
            },
            checkIsRecallWo: function (params) {
                return Q(http.get('/PreCheck/IsRecallWo', { params: params }));
            },
            scheduleRecommandTrack: function (params) {
                return Q(http.post('/Track/schedule', params));
            },
            urgentScheduleRecommandTrack: function (params) {
                return Q(http.post('/Track/new-urgent', params));
            },
            isEnableResidentSchedule: function () { return Q(http.get('/ResidentSchedule/IsEnable')); },
            canServiceScheduleOptimization: function (params, cancelToken) {
                return Q(http.get("/ScheduleOptimization/canService", { params: params, cancelToken: cancelToken, }));
            },
        };
    };
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceCategoryId", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceTypeId", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceCodeId", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "regionScriptPriority", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isPriorityBeRegionScriptModify", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "regionScriptClientNTE", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "regionScriptWoTypeId", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "storePriorityIdParam", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "storeWOTypeIdParam", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isRecallWo", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "hasRegionalScriptFutureToggle", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "urgentIHTNoRecommendSpecificProcess", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "hasDataInNotIH", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isCanServiceScheduleOptimization", void 0);
    __decorate([
        computed
    ], CreateWOStore.prototype, "serviceParam", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "isProcare", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "attachments", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "predictSearchValue", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "predictSearchListLoadingData", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "phoneNumber", void 0);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "initNoAvailableChecked", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "resetPredictSearch", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "setPredictSearchValue", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "getPhoneNumber", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "setAttachments", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "addAttachment", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "removeAttachment", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setReactiveWO", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "updateSubtaskStatusEventLog", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "defaultPriority", void 0);
    __decorate([
        computed
    ], CreateWOStore.prototype, "priorityId", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "resetPriorityId", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceCodeWOType", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "commonQuestion", void 0);
    __decorate([
        computed
    ], CreateWOStore.prototype, "commonQuestionAnswer", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceCodeQuestion", void 0);
    __decorate([
        computed
    ], CreateWOStore.prototype, "serviceCodeQuestionAnswer", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "allPriority", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "gateCode", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isCAHManaged", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "holidays", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "future24hoursMaxApparentTempInfo", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isAutoScheduleRegion", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "scheduleDate", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "serviceIssue", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "accessInformation", void 0);
    __decorate([
        computed
    ], CreateWOStore.prototype, "priority", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "showPreferedWindow", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "woTypeId", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "shouldRegionalScript", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "isInHouseTechnician", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "notRecall", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isNowCreateProCare", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "proCareProject", void 0);
    __decorate([
        action
    ], CreateWOStore.prototype, "getProcareProject", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "getisLastVersionAutoSchedule", null);
    __decorate([
        observable
    ], CreateWOStore.prototype, "locationId", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isLastVersionAutoSchedule", void 0);
    __decorate([
        observable
    ], CreateWOStore.prototype, "isEnableResidentSchedule", void 0);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "getIsEnableResidentSchedule", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "isAutoSchedule", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "criticalOrEmergency", null);
    __decorate([
        computed
    ], CreateWOStore.prototype, "isDisplayFuture24hoursMaxApparentTempInfo", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setServiceParam", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getDefaultPriority", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getServiceCodeWOType", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getCommonQuestion", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getServiceCodeQuestion", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getAllPriority", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setScheduleDate", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getIsAutoScheduleRegion", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getGateCode", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getIsCAHManaged", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getHolidays", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getFuture24hoursMaxApparentTempInfo", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "checkCreateWoScheduleTime", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "createWOCommit", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setCommonQuestionAnswer", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "logRegionalScriptChange", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setServiceCodeQuestionAnswer", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "loadFromSession", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "cleanSession", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "cleanData", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setServiceIssue", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "setAccessInformation", null);
    __decorate([
        action,
        serviceParamChecker
    ], CreateWOStore.prototype, "getLocationInfo", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "clearRegionScriptData", null);
    __decorate([
        action
    ], CreateWOStore.prototype, "getRegionScript", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "canServiceScheduleOptimization", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "checkIsRecallWo", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "scheduleRecommandTrack", null);
    __decorate([
        action.bound
    ], CreateWOStore.prototype, "urgentScheduleRecommandTrack", null);
    return CreateWOStore;
}());
export var buildURL = function (serviceParam) {
    return serviceParam
        ? "RSP/NewRequest/" + serviceParam.serviceCategoryId + "/" + serviceParam.serviceTypeId + "/" + serviceParam.serviceCodeId
        : "RSP/NewRequest";
};
var serviceParamChecker = paramChecker(function (instance, functionName) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var serviceParam = instance.serviceParam;
    if (serviceParam.serviceCategoryId && serviceParam.serviceTypeId && serviceParam.serviceCodeId) {
        return true;
    }
    console.error("service params lack of necessary argument,\n    the function [" + functionName + "] will not be called", toJS(serviceParam));
    return false;
});
export default CreateWOStore;
